import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import map from 'lodash/map';

import { updateBarberOrder } from '../actions';
import BarbersList from './BarbersList';
import { getAllConfirmed } from '../selector';
import withTimezone from '../../../auth/utils/withTimezone';
import fetchTimeTracking from '../../timeTracker/hoc/barberListFetchTimeTracking';
import withLoadingList from '../../../common/hoc/withLoaingList';
import EmptyList from './EmptyList';

const mapStateToProps = state => ({
  barbers: getAllConfirmed(state),
  shop: state.auth.shop,
  isBrandView: false,
  isSortable: true,
});

const mapDispatchToProps = {
  modifyOrder: updateBarberOrder,
};

export default compose(
  withTimezone,
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSortChange: props => (barbers) => {
      const data = map(barbers, (barber, index) => ({
        id: barber.id,
        order: index,
      }));
      props.modifyOrder(props.shop, data);
    },
  }),
  fetchTimeTracking,
  withLoadingList(
    props => props.barbers,
    EmptyList,
  )
)(BarbersList);
